import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgressbar } from 'react-circular-progressbar'

import colors from '@settings/styleSettings'
import { statusColors, statusTypes, statusDescriptions } from '@generators/tresholdConstants'
import { getMeterValue, getMeterColor } from '@util/meterUtil'
import Loading from '@components/loading'
import {
  CharacteristicContainer,
  CharacteristicInfoContainer,
  CharacteristicTitle,
  BeneficiaryPortion,
  ProgressBarContainer,
  StyledPopup,
  PopUpText,
} from './styles'

const ClassificationMeter = ({
  value,
  maxValue,
  type,
  style,
  status,
  onSelect,
  loading,
}) => {
  const percentage = maxValue === 0 ? 0 : getMeterValue(value, maxValue)
  let color = statusColors[type]
  if (!color) color = getMeterColor(percentage)
  return (
    <StyledPopup
      trigger={() => (
        <CharacteristicContainer
          style={{ ...style }}
          isSelected={status[type]}
          onClick={() => onSelect(type)}
        >
          {loading ? (
            <Loading
              color={colors.primary}
              height={40}
              width={40}
              style={{ marginLeft: '12px' }}
            />
          ) : (
            <ProgressBarContainer>
              <CircularProgressbar
                value={value}
                maxValue={maxValue === 0 ? 1 : maxValue}
                text={percentage === 0 ? '%' : `${percentage}%`}
                styles={{
                  root: {
                    dominantBaseline: 'middle',
                    textAnchor: 'middle',
                  },
                  path: {
                    stroke: color,
                    strokeLinecap: 'round',
                  },
                  trail: {
                    stroke: '#F2F3F5',
                  },
                  text: {
                    fill: colors.titleStrongBlack,
                    fontSize: '26px',
                    fontFamily: 'Circular-Std-Bold',
                  },
                }}
              />
            </ProgressBarContainer>
          )}
          <CharacteristicInfoContainer>
            <CharacteristicTitle>{statusTypes[type]}</CharacteristicTitle>
            <BeneficiaryPortion>{`${value}/${maxValue} beneficiários`}</BeneficiaryPortion>
          </CharacteristicInfoContainer>
        </CharacteristicContainer>

      )}
      on={['hover']}
      position="top left"
      closeOnDocumentClick
    >
      <PopUpText>{statusDescriptions[type]}</PopUpText>
    </StyledPopup>

  )
}

ClassificationMeter.propTypes = {
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
  status: PropTypes.shape({
    noRisk: PropTypes.bool,
    lowRisk: PropTypes.bool,
    mediumRisk: PropTypes.bool,
    highRisk: PropTypes.bool,
    diabetic: PropTypes.bool,
    hypertensive: PropTypes.bool,
    dyslipidemic: PropTypes.bool,
    overweight: PropTypes.bool,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
}

ClassificationMeter.defaultProps = {
  style: null,
}

export default ClassificationMeter
